<template>
	<div v-if="state.visible" class="promo-step__section promo-step__section--forecast">
		<v-switch :key="attempt" :model-value="state.active" color="success" hide-details density="compact" :disabled="state.locked" class="flex-grow-0" @update:model-value="onToggle" />
		<div class="text-high-emphasis">
			<div class="d-flex flex-wrap align-center ga-2 text-body-medium font-weight-bold">
				{{ t('PromoForecastMode') }}
				<v-chip v-if="state.lockReason === LOCK.PERIOD" color="forecast" size="x-small" prepend-icon="lock" label>{{ t('PromoForecastLocked') }}</v-chip>
			</div>
			<div class="text-body-small text-medium-emphasis">{{ t(hintKey) }}</div>
		</div>
	</div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { usePromoStep } from '@/composables/usePromoStep';
import { LOCK, forecastHintKey, getOfferForecastState } from '@/utils/domain/promo/promoForecast';

const props = defineProps({
	campaign: { type: Object, required: true },
	offerRef: { type: Object, required: true },
});

const { snapshot, ops, t } = usePromoStep();
const attempt = ref(0);

const state = computed(() => getOfferForecastState(snapshot.value, props.campaign, props.offerRef));
const hintKey = computed(() => forecastHintKey(snapshot.value, props.campaign, props.offerRef));

async function onToggle(value) {
	if (!value) await ops.deactivateForecast(props.offerRef);
	attempt.value += 1;
}
</script>
